export default "__VITE_ASSET__dc7c4dd8__"